export const convertMinuteToMs = (minute) => {
    return minute * 60000;

}